module.exports = __webpack_public_path__ + "static/img/hh3.bb50df03.png";